module.exports = __webpack_public_path__ + "img/placeholder_food.eeb0a476.png";